module.exports = __webpack_public_path__ + "static/img/rakez-slider1.45f0a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rakez-slider1.jpg
// module id = /Tij
// module chunks = 0